const OSS_SIGNATURE_EXPIRE_BUFFER_MS = 5 * 60 * 1000;

const signatureCache = {
  key: "",
  access: null,
  expiresAt: 0,
  pending: null
};

function decodeBase64(value) {
  if (!value) return "";
  if (typeof atob === "function") {
    return atob(value);
  }
  if (typeof Buffer !== "undefined") {
    return Buffer.from(value, "base64").toString("utf8");
  }
  return "";
}

function normalizeExpireTime(value) {
  if (!value) return 0;
  if (typeof value === "number" || /^\d+$/.test(String(value))) {
    var timestamp = Number(value);
    return timestamp < 1000000000000 ? timestamp * 1000 : timestamp;
  }
  var parsed = Date.parse(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function getOssSignatureExpiresAt(access) {
  if (!access) return 0;
  var directExpiresAt = normalizeExpireTime(access.expiresAt || access.expiration || access.expire);
  if (directExpiresAt) {
    return directExpiresAt;
  }

  try {
    var policy = JSON.parse(decodeBase64(access.policy));
    return normalizeExpireTime(policy.expiration);
  } catch (error) {
    return 0;
  }
}

export function isOssSignatureValid(access, now) {
  if (!access || !access.OSSAccessKeyId || !access.policy || !access.signature) {
    return false;
  }
  var expiresAt = getOssSignatureExpiresAt(access);
  var currentTime = typeof now === "number" ? now : Date.now();
  return expiresAt - OSS_SIGNATURE_EXPIRE_BUFFER_MS > currentTime;
}

export async function getCachedOssSignature(cacheKey, fetchSignature, options) {
  options = options || {};
  var now = typeof options.now === "number" ? options.now : Date.now();
  if (options.forceRefresh &&
      signatureCache.key === cacheKey &&
      signatureCache.pending) {
    return signatureCache.pending;
  }
  if (!options.forceRefresh &&
      signatureCache.key === cacheKey &&
      isOssSignatureValid(signatureCache.access, now)) {
    return signatureCache.access;
  }
  if (!options.forceRefresh &&
      signatureCache.key === cacheKey &&
      signatureCache.pending) {
    return signatureCache.pending;
  }

  signatureCache.key = cacheKey;
  if (options.forceRefresh) {
    signatureCache.access = null;
    signatureCache.expiresAt = 0;
  }
  signatureCache.pending = Promise.resolve()
    .then(fetchSignature)
    .then(function (access) {
      signatureCache.access = access || null;
      signatureCache.expiresAt = getOssSignatureExpiresAt(access);
      signatureCache.pending = null;
      return access;
    }, function (error) {
      signatureCache.pending = null;
      throw error;
    });
  return signatureCache.pending;
}

export function clearCachedOssSignature(cacheKey) {
  if (cacheKey && signatureCache.key !== cacheKey) {
    return;
  }
  signatureCache.key = "";
  signatureCache.access = null;
  signatureCache.expiresAt = 0;
  signatureCache.pending = null;
}

export function getOssSignatureCacheState() {
  return Object.assign({}, signatureCache);
}



// WEBPACK FOOTER //
// ./src/utils/ossSignatureCache.js